<clr-vertical-nav class="files-nav" [clrVerticalNavCollapsible]="false" aria-label="Apps groups files">
  <a clrVerticalNavLink class="new-file-link" role="button" tabindex="0" (click)="startFileCreation()"
     (keydown.enter)="startFileCreation()">
    <cds-icon shape="plus" clrVerticalNavIcon></cds-icon>
    New file
  </a>
  <div class="nav-divider"></div>

  <clr-vertical-nav-group [clrVerticalNavGroupExpanded]="true">
    <cds-icon shape="file-group" clrVerticalNavIcon></cds-icon>
    Your files
    <clr-vertical-nav-group-children>
      @for (file of userFiles; track file.name) {
        <a clrVerticalNavLink role="button" tabindex="0" [class.active]="file.name == selectedFile"
           [attr.aria-current]="file.name == selectedFile ? 'page' : null"
           (click)="selectFile(file)" (keydown.enter)="selectFile(file)">
          <span class="file-name">{{ file.name }}</span>
          @if (file.groupsCount != undefined) {
            <span class="badge">{{ file.groupsCount }}</span>
          }
        </a>
      } @empty {
        <span class="nav-link empty">No file yet</span>
      }
    </clr-vertical-nav-group-children>
  </clr-vertical-nav-group>

  <clr-vertical-nav-group [clrVerticalNavGroupExpanded]="true">
    <cds-icon shape="lock" clrVerticalNavIcon></cds-icon>
    Generated
    <clr-vertical-nav-group-children>
      @for (file of generatedFiles; track file.name) {
        <a clrVerticalNavLink role="button" tabindex="0" [class.active]="file.name == selectedFile"
           [attr.aria-current]="file.name == selectedFile ? 'page' : null"
           (click)="selectFile(file)" (keydown.enter)="selectFile(file)"
           title="Generated by DC Netscope and kept in sync automatically. Read-only.">
          <span class="file-name">{{ file.name }}</span>
          @if (file.groupsCount != undefined) {
            <span class="badge">{{ file.groupsCount }}</span>
          }
        </a>
      } @empty {
        <span class="nav-link empty">No generated file yet</span>
      }
    </clr-vertical-nav-group-children>
  </clr-vertical-nav-group>

  @if (failureMode) {
    <clr-alert [clrAlertType]="'danger'" [clrAlertClosable]="false" [clrAlertSizeSmall]="true">
      <clr-alert-item>
        <span class="alert-text">The apps groups files could not be loaded.</span>
      </clr-alert-item>
    </clr-alert>
  }
</clr-vertical-nav>

<clr-modal [(clrModalOpen)]="creatingFile" [clrModalSize]="'sm'">
  <h3 class="modal-title">New file</h3>
  <div class="modal-body">
    <p class="modal-intro">A file is a set of groups you manage together, for an application, a team or a site.</p>
    @if (creatingFile) {
      <form clrForm clrLayout="vertical" id="apps-groups-new-file-form" (ngSubmit)="createFile()">
        <div class="clr-form-control">
          <label for="apps-groups-new-file" class="clr-control-label">Name</label>
          <div class="clr-control-container" [class.clr-error]="newFileNameError != undefined">
            <div class="clr-input-wrapper">
              <input id="apps-groups-new-file" name="newFileName" type="text" class="clr-input" autocomplete="off"
                     placeholder="e.g. billing" [(ngModel)]="newFileName" autofocus>
              <cds-icon class="clr-validate-icon" shape="exclamation-circle" status="danger" aria-hidden="true"></cds-icon>
            </div>
            <span class="clr-subtext" [attr.role]="newFileNameError ? 'alert' : null">
              {{ newFileNameError ?? "Letters, digits, '_' and '-'." }}
            </span>
          </div>
        </div>
      </form>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="cancelFileCreation()">Cancel</button>
    <button type="submit" form="apps-groups-new-file-form" class="btn btn-primary">Create</button>
  </div>
</clr-modal>
